import { render, staticRenderFns } from "./MonteCarlo.vue?vue&type=template&id=640890a6&scoped=true"
import script from "./MonteCarlo.vue?vue&type=script&lang=js"
export * from "./MonteCarlo.vue?vue&type=script&lang=js"
import style0 from "./MonteCarlo.vue?vue&type=style&index=0&id=640890a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640890a6",
  null
  
)

export default component.exports